import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import './TextAnswer.less';

export function TextAnswer({ error, question }) {
  return (
    <Field as="textarea" className={`text_answer ${error ? 'error' : ''}`} id={question.question_id} name="answer" placeholder={question.placeholder} />
  );
}

TextAnswer.propTypes = {
  error: PropTypes.string,
  question: PropTypes.shape({
    question_id: PropTypes.number,
    placeholder: PropTypes.string,
  }).isRequired,
};

TextAnswer.defaultProps = {
  error: '',
};

export default TextAnswer;
